<div class="tuning-container">
  <div class="tuning-header">
    <hyperkit-typography variant="h4" align="left" color="primary"
      >Tuning</hyperkit-typography
    >
    <hyperkit-icon
      (click)="toggleTuning()"
      size="medium"
      variant="icon"
      icon="x"
      color="primary"
    ></hyperkit-icon>
  </div>
  @if (tuningText()) {
    <hyperkit-message
      [text]="tuningText()"
      type="info"
      [closable]="false"
    ></hyperkit-message>
  }
  <div class="tuning-editor">
    <div class="tool-bar">
      <hyperkit-button
        (click)="copyTuning()"
        size="small"
        variant="icon"
        icon="copy"
        color="secondary"
      ></hyperkit-button>
    </div>
    <hyperkit-code-editor
      [value]="emitted()"
      height="50px"
      [options]="{ language: 'json', readOnly: true }"
    >
    </hyperkit-code-editor>
  </div>

  @if (filters().length > 0) {
    <div class="filters-section-wrapper">
      <hyperkit-typography variant="h5" align="left" color="primary">
        Applied filters
      </hyperkit-typography>
      <div class="filter-scroll-wrapper">
        <kendo-filter
          [filters]="filters()"
          [value]="filterValue()"
          (valueChange)="onValueChange($event)"
        >
        </kendo-filter>
      </div>
    </div>
  }
</div>
